/**
 * 表紙特集掲載商品選定（CX）画面の候補一覧クラス
 *
 * @export TargetListInfo
 * @class TargetListInfo
 */
export class TargetListInfo {
  constructor(
    // チェックボックス
    public check: boolean = false,
    // チェックボックス活性制御
    public checkFlag: boolean = false,
    // Pコード
    public pCode: string = null,
    // アイテムコード
    public itemCode: string = null,
    // 商品名
    public guideGoodsName: string = null,
    // 規格名
    public guideStandardName: string = null,
    // 部門コード
    public classCode: string = null,
    // 部門名
    public classNameKanji: string = null,
    // フォーマット部門
    public formatClass: string = null,
    // 大分類コード
    public largeClassCode: string = null,
    // 大分類名
    public largeClassNameKanji: string = null,
    // フォーマット大分類
    public formatLargeClass: string = null,
    // 中分類コード
    public middleClassCode: string = null,
    // 中分類名
    public middleClassNameKanji: string = null,
    // フォーマット中分類
    public formatMiddleClass: string = null,
    // 小分類コード
    public smallClassCode: string = null,
    // 小分類名
    public smallClassNameKanji: string = null,
    // フォーマット小分類
    public formatSmallClass: string = null,
    // タグ名
    public tagName: string = null,
    // 今回供給価格
    public thisTimeSupplyPrice: string = null,
    // 供給価格（通常）
    public supplyPriceStandard: string = null,
    // 供給価格（特価1）
    public supplyPriceSpecial1: string = null,
    // 供給価格（特価2）
    public supplyPriceSpecial2: string = null,
    // 仕入価(今回仕入価格)
    public thisTimeCostPrice: string = null,
    // 単品仕入価格（通常）
    public costPriceStandard: string = null,
    // 単品仕入価格（特価1）
    public costPriceSpecial1: string = null,
    // 単品仕入価格（特価2）
    public costPriceSpecial2: string = null,
  ) {}
}
